import { useRecordContext } from "react-admin";
import { DrivingLicenseAuthority } from "../../providers/drivingLicenseAuthoritiesProvider";
import { Column } from "../../misc/Column";
import { drivingSchoolsProvider } from "../../providers/drivingSchoolsProvider";
import { Row } from "../../misc/Row";
import { DrivingSchoolLogo } from "../../misc/DrivingSchoolLogo";
import { Box, CircularProgress, IconButton, ListItemIcon, Menu, MenuItem } from "@mui/material";
import { ListWithDividers } from "../../misc/ListWithDividers";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { useMenu } from "../../hooks/useMenu";
import { serverAPI } from "../../api/server.api";
import { useState } from "react";

export function AssignedBranches() {
  const authority = useRecordContext<DrivingLicenseAuthority>();

  return (
    <ListWithDividers items={authority.assignedBranches} emptyText="Keine Filialen zugeordnet.">
      {(branch) => <AssignedBranchItem branch={branch} authorityId={authority.id} />}
    </ListWithDividers>
  );
}

function AssignedBranchItem(props: { branch: { id: string; drivingSchoolId: string }; authorityId: string }) {
  const { branch, authorityId } = props;
  const { id: branchId, drivingSchoolId } = branch;
  const { anchorEl, open, openMenu, closeMenu } = useMenu();
  const [removingBranch, setRemovingBranch] = useState(false);

  const drivingSchool = drivingSchoolsProvider.getOneFromCache(drivingSchoolId);
  const assignedBranch = drivingSchool?.branches.find((it) => it.uid === branchId);

  const removeAssignment = async () => {
    setRemovingBranch(true);
    await runSafely(() => serverAPI.unassignBranchFromDrivingLicenseAuthority({ authorityId, branchId }), {
      errorMessage: "Fehler beim Entfernen der Zuordnung.",
      onSuccess: closeMenu,
      successMessage: "Zuordnung erfolgreich entfernt.",
    });
    setRemovingBranch(false);
  };

  return (
    <Row gap="10px" sx={{ alignItems: "center", justifyContent: "space-between" }}>
      <Row gap="10px" sx={{ alignItems: "center" }}>
        <DrivingSchoolLogo drivingSchool={drivingSchool} />
        <Column>
          <Box sx={{ fontSize: "14px" }}>{drivingSchool?.name ?? `Fahrschule ${drivingSchoolId}`}</Box>
          <Box sx={{ fontSize: "12px", color: "text.secondary" }}>{assignedBranch?.name ?? "???"}</Box>
        </Column>
      </Row>
      <IconButton aria-label="Öffne Menü" onClick={openMenu} size="small">
        <MoreVertIcon />
      </IconButton>
      <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
        <MenuItem onClick={removeAssignment} disabled={removingBranch}>
          <ListItemIcon>
            {removingBranch ? <CircularProgress size={16} /> : <DeleteOutlineIcon fontSize="small" />}
          </ListItemIcon>
          Zuordnung löschen
        </MenuItem>
      </Menu>
    </Row>
  );
}
